import { CardBody, Col, FormGroup, Row } from "reactstrap"
import { LabelText } from "../Utils/Input"
import { RenderField } from "../Utils/renderFields"
import { RenderErrorMessage } from "../Utils/renderErrorMessages"
import formSchema from '../Utils/schema.json';
import PhoneInput from 'react-phone-number-input';
import React, { useEffect } from "react";

export const CustomerEditProfile = ({ setSelectedState, setSelectedCountry, profileOptions, values, setFieldTouched, setFieldValue, touched, errors, handleBlur, handleChange, stateData, cityData, dialCode, setDialCode }) => {
    useEffect(() => {
        formSchema.forEach((section) => {
            if (section.title === "Customer" && section.sections) {
                section.sections.forEach((subSection) => {
                    subSection.fields.forEach((field) => {
                        if (field.name === "userName") {
                            field.disable = true;
                        }
                    });
                });
            }
        })
    }, []);
    return (
        <Row>
            <Col xxl={12} md={12} className="my-3">
                {formSchema.map((section, sectionIndex) => (
                    <React.Fragment key={sectionIndex}>
                        {section.title === "Customer" && section.sections &&
                            section.sections.map((subSection, subSectionIndex) => (
                                (subSection.sectionTitle !== "Primary Contact 2" && <CardBody key={subSectionIndex}>
                                    <Row className='gy-4'>
                                        {subSection.fields.map((field, fieldIndex) => (
                                            <Col
                                                xxl={4}
                                                md={6}
                                                lg={4}
                                                key={`${subSectionIndex}-${fieldIndex}`}
                                            >
                                                <LabelText
                                                    htmlFor={field.name}
                                                    classLabelName={
                                                        "ms-0 rv-form-label"
                                                    }
                                                    className={field.required ? "text-danger" : ""}
                                                    displayText={field.label}
                                                    important={field.required ? "*" : ""}
                                                />
                                                <LabelText
                                                    htmlFor={field.name}
                                                    classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] &&
                                                        errors[field.name]
                                                        ? "rv-label-danger"
                                                        : "rv-label-muted"
                                                        } `}
                                                    displayText={field.placeholder
                                                    }
                                                />
                                                {field.type === 'phone' ? (
                                                    <>
                                                        <PhoneInput
                                                            international
                                                            countryCallingCodeEditable={false}
                                                            className={`form-control ${touched[field.name] && errors[field.name] ? 'error-input' : ''}`}
                                                            placeholder={field.placeholder}
                                                            value={dialCode}
                                                            onChange={setDialCode}
                                                            onBlur={() => setFieldTouched(field.name, true)}
                                                            disabled={field?.autoload && field.isEdit}
                                                        />
                                                        {/* {touched[field.name] && errors[field.name] && (
                                                            <div className="text-danger validation-font-size">
                                                                {errors[field.name]}
                                                            </div>
                                                        )} */}
                                                    </>
                                                ) : (
                                                    <>
                                                        <RenderField
                                                            field={field}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            values={values}
                                                            touched={touched}
                                                            errors={errors}
                                                            setFieldTouched={setFieldTouched}
                                                            setFieldValue={setFieldValue}
                                                            removePlaceholder={true}
                                                        />
                                                        {/* <RenderErrorMessage
                                                            field={field}
                                                            touched={touched}
                                                            errors={errors}
                                                        /> */}
                                                    </>
                                                )}
                                            </Col>
                                        ))}
                                    </Row>
                                </CardBody>
                                )
                            ))}
                    </React.Fragment>
                ))}
            </Col>
            <Col xxl={12} md={12} classNam="my-3">
                {formSchema.map((section, sectionIndex) => (
                    <React.Fragment key={sectionIndex}>
                        {section.title === "Customer" && section.sections &&
                            section.sections.map((subSection, subSectionIndex) => (
                                (subSection.sectionTitle !== "Primary Contact 1" && <CardBody key={subSectionIndex}>
                                    <Row className='gy-4'>
                                        {subSection.fields.filter(field => {
                                            if (field.name === "country" && stateData) {
                                                profileOptions.push(stateData)
                                            }
                                            if (field.name === "state" && cityData) {
                                                profileOptions.push(cityData)
                                            }
                                            return true
                                        }).map((field, fieldIndex) => (
                                            <Col
                                                xxl={4}
                                                md={6}
                                                lg={6}
                                                key={`${subSectionIndex}-${fieldIndex}`}
                                            >
                                                 <LabelText
                                                    htmlFor={field.name}
                                                    classLabelName={
                                                        "ms-0 rv-form-label"
                                                    }
                                                    className={field.required ? "text-danger" : ""}
                                                    displayText={field.label}
                                                    important={field.required ? "*" : ""}
                                                />
                                                  <LabelText
                                                    htmlFor={field.name}
                                                    classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] &&
                                                        errors[field.name]
                                                        ? "rv-label-danger"
                                                        : "rv-label-muted"
                                                        } `}
                                                    displayText={field.placeholder
                                                    }
                                                />
                                                <RenderField
                                                    field={field}
                                                    handleChange={handleChange}
                                                    handleBlur={handleBlur}
                                                    values={values}
                                                    touched={touched}
                                                    errors={errors}
                                                    setFieldTouched={setFieldTouched}
                                                    setFieldValue={setFieldValue}
                                                    setSelectedCountry={setSelectedCountry}
                                                    setSelectedState={setSelectedState}
                                                    options={profileOptions}
                                                    removePlaceholder={true}
                                                />
                                                {/* <RenderErrorMessage
                                                    field={field}
                                                    touched={touched}
                                                    errors={errors}
                                                /> */}
                                            </Col>
                                        ))}
                                    </Row>
                                </CardBody>
                                )
                            ))}
                    </React.Fragment>
                ))}
            </Col>
        </Row>
    )
}